export const MEMBERSHIP_BILLING_INTERVAL = Object.freeze({
  MONTHLY: 'MONTHLY',
  ANNUAL: 'ANNUAL',
});

export const BILLING_INTERVAL_OPTIONS_FIELDS = `
billingIntervalOptions {
  currentInterval
  targetInterval
  targetPrice
  annualSaving
}
`;
